import type { Environment } from './environment.interface';

/** Development. Replaced at build time by `environment.production.ts`. */
export const environment: Environment = {
  production: false,
  apiBaseUrl: '',
  siteUrl: 'http://localhost:4301',
  debug: true,
  devTools: true,
  reportingTimeZone: { label: 'Asia/Dhaka', utcOffset: '+06:00', offsetMinutes: 360 },
};
